<template>
  <div>
    <i
      class="bi bi-info-circle-fill fs-3 text-info help"
      @mouseover="showText = true"
      @mouseleave="showText = false"
    ></i>
    <div v-if="showText" class="info-text">{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: 'InfoButton',
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showText: false
    }
  }
}
</script>

<style scoped>
.help {
  cursor: help;
}

.info-text {
  position: absolute;
  z-index: 599;
  border: 1px solid #aaa;
  min-width: 64px;
  max-width: 250px;
  min-height: 64px;
  background: white;
  padding: 8px;
  border-radius: 5px;
}
</style>
